import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { testimonials } from "@/mocks/public";

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="container-page">
        <SectionHeading
          eyebrow="Témoignages"
          title="Ils ont repris le contrôle de leur gestion"
          description="Des propriétaires et des agences qui suivent désormais leurs immeubles et leurs loyers sereinement."
        />
        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item, index) => (
            <Reveal key={item.name} delay={index * 110} className="h-full">
              <figure className="card-lift flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 hover:border-primary-300">
                <div className="flex items-center gap-1 text-accent-500">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <i key={i} className="ri-star-fill text-sm" aria-hidden="true" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  « {item.quote} »
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-semibold text-primary-800">
                    {item.initials}
                  </span>
                  <div>
                    <p className="text-sm font-label font-semibold text-foreground-950">{item.name}</p>
                    <p className="text-xs text-foreground-500">{item.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}